import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

// Should fetch products and create a dictionary like this.
// const products = { id1: "Product 1", id2: "Product 2" };

const AddProduct = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [skuInput, setSkuInput] = useState<string | null>(actionStep?.action?.data.sku || null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: isFixed ? ActionType.CART_ADD_SPECIFIC_PRODUCT : ActionType.CART_ADD_PRODUCT,
            data: { isFixed, sku: isFixed ? skuInput : undefined }
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isFixed, skuInput]);

    const tPrefix = "popup.actionBuilder.";

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Add active product to cart" size="xs" weight="medium-heavy" translatePrefix={tPrefix} />
                        <OliverText text="The active selected product will be added to cart" size="xs" weight="light" translatePrefix={tPrefix} />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Add a specific SKU to cart" size="xs" weight="medium-heavy" translatePrefix={tPrefix} />
                        <OliverText text="This will add the product of your choosing to cart" size="xs" weight="light" translatePrefix={tPrefix} />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <TextInput
                        title=""
                        callback={setSkuInput}
                        value={skuInput || ""}
                        className="actions-tab-input"
                        placeholder="Enter product SKU"
                    />
                ) : null}
            </div>
        </div>
    );
};

export default AddProduct;
